<template>
  <div>

  </div>
</template>

<script>
export default {
  name: "BlogDesktop"
}
</script>

<style scoped>

</style>